import { mainAxios } from "../mainAxios";
import { getDefaultHeaders } from "./mainService";

export const sendMailEscaladoAseguradora = async (payload) => {
    try {
        const response = await mainAxios.post(
            `/v1/escalar/aseguradora/mail`,
            payload,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        console.warn(error);
        return error.response.data
    }
};
